/* eslint-disable */
import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import Login from 'views/auth/login';
import DomainOrHosting from 'views/admin/invoice/DomainOrHosting';

const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const EditProfile = Loadable(lazy(() => import('views/dashboard/EditProfile')));
const InvoiceGenerate = Loadable(lazy(() => import('views/admin/invoice/InvoiceGenerate')));
const InvoiceSetting = Loadable(lazy(() => import('views/admin/invoice/InvoiceSetting')));
const PrintInvoice = Loadable(lazy(() => import('views/admin/invoice/PrintInvoice')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: 'login',
      element: <Login />,
    },
    {
      path: '/',
      element: <MainLayout />,
      children: [
        {
          path: 'dashboard',
          element: <DashboardDefault />,
        },
        {
          path: 'editprofile',
          element: <EditProfile />,
        },
        {
          path: 'invoice',
          element: <InvoiceGenerate />,
        },
        {
          path: 'invoice-setting',
          element: <InvoiceSetting />,
        },
        {
          path: 'domain-hosting',
          element: <DomainOrHosting />,
        },
        {
          path: 'print-invoice/:id',
          element: <PrintInvoice />,
        }

      ],
    },
  ],
};

export default MainRoutes;
